<mat-toolbar class="px-3 caller-navbar">
  <!-- Left side: Logo -->
  <img 
    (click)="goToHomePage()" 
    [ngSrc]="logoUrl"
    alt="Logo"
    class="logo img-fluid pt-1 pb-1 d-none d-md-block"
    width="200"
    height="31"
    loading="lazy"
  />
  
  <!-- Right side: Icon buttons and user button -->
  <ul class="ms-auto navbar-nav">
    <!-- Programmatically configured buttons -->
    @for (button of navbarButtons(); track button.id) {
      @if (button.visible()) {
        <li class="nav-item">
          @if (button.buttonType === 'mini-fab') {
            <button 
              mat-mini-fab 
              (click)="button.action()" 
              [title]="button.title"
              [class]="button.classes?.join(' ') || ''"
              [matBadge]="button.badge?.value() || 0"
              [matBadgePosition]="button.badge?.position || 'after'"
              [matBadgeColor]="button.badge?.color || 'primary'"
              [matBadgeHidden]="button.badge?.hidden() ?? true"
              matBadgeSize="large"
              [disabled]="button.action.toString().includes('{}')"
            >
              @if (button.id === 'bcp-messages-with-count') {
                {{ bcpMessageCount() }}
              }
              <mat-icon>{{ button.icon }}</mat-icon>
            </button>
          } @else {
            <button
              mat-flat-button
              (click)="button.action()"
              [title]="button.title"
              [class]="button.classes?.join(' ') || ''"
              [disabled]="button.action.toString().includes('{}')"
            >
              @if (button.id === 'bcp-messages-with-count') {
                {{ bcpMessageCount() }}
              }
              <mat-icon>{{ button.icon }}</mat-icon>
            </button>
          }
        </li>
      }
    }
    
    <!-- EESZT auth button (red when not authenticated) -->
    @if (isPathologist() && !eszigTokenValid()) {
      <li class="nav-item">
        <button
          mat-mini-fab
          class="redCloud"
          (click)="openEesztAuthModal()"
          title="EESZT autentikáció"
        >
          <mat-icon>cloud</mat-icon>
        </button>
      </li>
    }

    <!-- EESZT identifiers of the logged-in user (accreditation) -->
    @if (showEesztIdentifiers()) {
      <li class="nav-item">
        <dl class="eeszt-identifiers">
          @for (identifier of eesztIdentifiers(); track identifier.label) {
            <div>
              <dt>{{ identifier.label }}</dt>
              <dd>{{ identifier.value || '–' }}</dd>
            </div>
          }
        </dl>
      </li>
    }

    <!-- EESZT button (green when authenticated) -->
    @if (showEeszt()) {
      <li class="nav-item">
        <button
          mat-flat-button
          class="greenCloud"
          (click)="goToEeszt()"
          title="EESZT"
        >
          <mat-icon>cloud</mat-icon>
          <span class="ms-2">{{ remainingSeconds() | countdown }}</span>
        </button>
      </li>
    }
    
    <!-- Logout button with username -->
    <li class="nav-item" title="Kijelentkezés">
      <button mat-flat-button (click)="logout()" [disabled]="isLoggingOut()">
        {{ username() }}
        <mat-icon>logout</mat-icon>
      </button>
    </li>
  </ul>
</mat-toolbar>
